<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/stores' }">门店管理</el-breadcrumb-item>
            <el-breadcrumb-item>添加门店</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区-->
        <el-card>
            <el-form :model="addForm" :rules="addFormRules" ref="addFormRef"  label-width="130px" class="store-form" style="width:90%;margin:10px auto">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="门店名称" prop="storename">
                    <el-input v-model="addForm.storename"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="所属城市" prop="city">
                    <el-cascader
                        v-model="citySelection"
                        :options="citylist"
                        style="width: 100%"
                        clearable
                        filterable
                        @change="handleChange"
                        @blur="onCityBlur"
                        @input.native="onCityNativeInput"></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="门店照片" prop="goods_pic">
                  <el-upload
                      ref="imgBroadcastUpload"
                      :limit="limitNum"
                      :auto-upload="true"
                      :file-list="fileList"
                      :on-success="addPic"
                      list-type="picture-card"
                      accept=".jpg,.png"
                      :before-upload="beforePicUpload"
                      :action="uploadurl">
                          <i class="el-icon-plus"></i>
                          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                  </el-upload>
              </el-form-item>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="门店位置" prop="address">
                    <el-input v-model="addForm.address" clearable @input="addressChange(15)"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                 <el-form-item prop="longitude" label="经纬度">
                   <div style="display: flex;">
                     <el-input v-model="addForm.longitude" placeholder="经度" style="flex: 1" @blur="validateField('longitude')"></el-input>
                     <div>
                       -
                     </div>
                     <el-input v-model="addForm.latitude" placeholder="纬度" style="flex: 1" @blur="validateField('longitude')"></el-input>
                   </div>
                 </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="门店定位" prop="location">
                <tx-map ref="map" @setAddress="setAddress" />
              </el-form-item>
              <el-row :gutter="10">
<!--                <el-col :span="12">-->
<!--                  <el-form-item label="操房数量" prop="roomnum">-->
<!--                    <el-input v-model="addForm.roomnum" >-->
<!--                      <template slot="append">间</template>-->
<!--                    </el-input>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="12">
                  <el-form-item label="门店面积" prop="storearea">
                    <el-input v-model="addForm.storearea"  >
                      <template slot="append">㎡</template>
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="wifi" prop="wifi">
                    <el-input v-model="addForm.wifi" ></el-input>
                  </el-form-item>
                </el-col>

              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <!-- tag-block 只作「保存失败后滚到这里」的锚点 -->
                  <div ref="tagBlock1" class="tag-block">
                    <el-form-item label="门店服务" prop="serviceTags" v-permission="'btn:store:field:services'">
                      <!-- 自定义标签池：勾选按原样式，管理按钮挂在最后一组末尾（空池时 serviceRows=[[]]，按钮仍有处挂） -->
                      <el-checkbox-group v-model="selectedServiceUids" class="tag-group">
                        <div v-for="(row, ri) in serviceRows" :key="ri" class="tag-row">
                          <span v-if="row.length === 0" class="tag-empty">暂未提供</span>
                          <el-checkbox v-for="(item, i) in row" :key="item.uid" :label="item.uid"
                                       :disabled="isServiceTagFull(item)"
                                       :title="isServiceTagFull(item) ? '门店服务最多选择 6 个' : ''"
                                       :class="{ 'tag-dup': isErrorTag(1, item, ri * 10 + i) }">{{ item.name }}</el-checkbox>
                          <el-button
                            v-if="ri === serviceRows.length - 1"
                            type="text" icon="el-icon-setting" class="tag-manage-btn"
                            @click="openTagDialog(1)">自定义标签管理</el-button>
                        </div>
                      </el-checkbox-group>
                      <!-- 错误条放在勾选组外面：组内是 flex 标签流，红字混进去会被当成标签排、还会挤掉管理按钮 -->
                      <div v-if="errorsOf(1).length" class="tag-error">
                        <i class="el-icon-warning"></i>
                        <span>{{ errorText(1) }}</span>
                        <el-button v-if="hasRowError(1)" type="text" class="tag-error-fix"
                                   @click="fixTags(1)">去修改</el-button>
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div ref="tagBlock2" class="tag-block">
                    <el-form-item label="设施设备" prop="facilityTags" v-permission="'btn:store:field:facilities'">
                      <el-checkbox-group v-model="selectedFacilityUids" class="tag-group">
                        <div v-for="(row, ri) in facilityRows" :key="ri" class="tag-row">
                          <span v-if="row.length === 0" class="tag-empty">暂未提供</span>
                          <el-checkbox v-for="(item, i) in row" :key="item.uid" :label="item.uid"
                                       :class="{ 'tag-dup': isErrorTag(2, item, ri * 10 + i) }">{{ item.name }}</el-checkbox>
                          <el-button
                            v-if="ri === facilityRows.length - 1"
                            type="text" icon="el-icon-setting" class="tag-manage-btn"
                            @click="openTagDialog(2)">自定义标签管理</el-button>
                        </div>
                      </el-checkbox-group>
                      <div v-if="errorsOf(2).length" class="tag-error">
                        <i class="el-icon-warning"></i>
                        <span>{{ errorText(2) }}</span>
                        <el-button v-if="hasRowError(2)" type="text" class="tag-error-fix"
                                   @click="fixTags(2)">去修改</el-button>
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="10">

                <el-col :span="12">
                  <el-form-item label="门店简介" prop="jianjie">
                    <el-input v-model="addForm.jianjie" type="textarea" :rows="3" maxlength="100" show-word-limit ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="设备类型" prop="newFlag">
                    <el-radio-group v-model="addForm.newFlag" @change="handleFlagChange">
                      <el-radio :label="'N'">旧设备</el-radio>
                      <el-radio :label="'Y'">新设备</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="抖音门店ID" prop="dystoreid">
                    <el-input v-model="addForm.dystoreid"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="高德门店ID" prop="gaodestoreid">
                    <el-input v-model="addForm.gaodestoreid"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="状态" prop="isopen">
                    <el-select  v-model="addForm.isopen"  placeholder="请选择状态" @change="handleFlagChange" style="width:100%">
                      <el-option v-for="item in statuslist" :key="item.id" :label="item.status" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="歇业日期">
                    <el-date-picker
                        v-model="xyDates"
                        style="width:100%"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="开始时间" prop="openStoreTime">
                    <el-time-picker
                        v-model="addForm.openStoreTime"
                        @change="handleOpenStoreTime"
                        style="width:100%"
                        placeholder="开始时间">
                    </el-time-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="结束时间" prop="closeStoreTime">
                    <el-time-picker
                        v-model="addForm.closeStoreTime"
                        @change="handleOpenStoreTime"
                        style="width:100%"
                        placeholder="结束时间">
                    </el-time-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="客服微信" prop="wechat">
                    <el-input v-model="addForm.wechat"  ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客服电话" prop="telephone">
                    <el-input v-model="addForm.telephone"  ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="门店序号" prop="xh">
                    <el-input v-model="addForm.xh"  ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="音乐TOPIC" prop="musicTopic">
                    <el-input v-model="addForm.musicTopic"  ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="大屏TOPIC" prop="dashboardTopic">
                    <el-input v-model="addForm.dashboardTopic"  ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="店主数量" prop="ownerNum">
                    <el-input v-model="addForm.ownerNum"  ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="店长数量" prop="managerNum">
                    <el-input v-model="addForm.managerNum"  ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="店员数量" prop="associateNum">
                    <el-input v-model="addForm.associateNum"  ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="保洁数量" prop="clearNum">
                    <el-input v-model="addForm.clearNum"  ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="保洁每月可改次数" prop="settingNum">
                    <el-input v-model="addForm.settingNum"  ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="用户停卡" prop="stopCard">
                    <el-radio-group v-model="addForm.stopCard">
                      <el-radio :label="'0'">开启</el-radio>
                      <el-radio :label="'1'">关闭</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="进店1Sn" prop="sn">
                    <el-input v-model="addForm.sn" ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="出店1Sn" prop="outsn">
                    <el-input v-model="addForm.outsn"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="进店2Sn" prop="sn1">
                    <el-input v-model="addForm.sn1" @change="handleTwoDoorChange"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="出店2Sn" prop="outsn1">
                    <el-input v-model="addForm.outsn1" @change="handleTwoDoorChange"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="鱼眼1Sn" prop="fishsn">
                    <el-input v-model="addForm.fishsn"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="鱼眼2Sn" prop="fishsn1">
                    <el-input v-model="addForm.fishsn1"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="10" v-if="addForm.isNewZhuapai === '0'">
<!--              <el-row :gutter="10">-->
                <el-col :span="12">
                  <el-form-item label="摄像头1Sn" prop="camera1">
                    <el-input v-model="addForm.camera1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="摄像头2Sn" prop="camera2">
                    <el-input v-model="addForm.camera2"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-if="addForm.isNewZhuapai === '0'">
<!--              <el-row :gutter="10">-->
                <el-col :span="12">
                  <el-form-item label="摄像头3Sn" prop="camera3">
                    <el-input v-model="addForm.camera3"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="摄像头4Sn" prop="camera4">
                    <el-input v-model="addForm.camera4"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-if="addForm.isNewZhuapai === '1'">
                <el-col :span="12">
                  <el-form-item label="录像机IP" prop="lxjIp">
                    <el-input v-model="addForm.lxjIp"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="摄像头数量" prop="zhuapaiNum">
                    <el-input v-model="addForm.zhuapaiNum"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-if="addForm.newFlag === 'N'">
                <el-col :span="12">
                  <el-form-item label="边缘盒子Sn" prop="boxsn">
                    <el-input v-model="addForm.boxsn"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="温湿度Sn" prop="wsdsn">
                    <el-input v-model="addForm.wsdsn"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="10" v-if="addForm.newFlag === 'Y'">
                <el-col :span="12">
                  <el-form-item label="人脸类型" prop="faceLocal">
                    <el-radio-group v-model="addForm.faceLocal">
                      <el-radio :label="'N'">线上</el-radio>
                      <el-radio :label="'Y'">本地</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="抓拍类型" prop="isNewZhuapai">
                    <el-radio-group v-model="addForm.isNewZhuapai" @change="handleZhapaiChange">
                      <el-radio :label="'0'">京目</el-radio>
                      <el-radio :label="'1'">海康</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="10" v-if="addForm.faceLocal === 'Y'">
                <el-col :span="12">
                  <el-form-item label="人脸识别" prop="faceDeviceType">
                    <el-radio-group v-model="addForm.faceDeviceType">
                      <el-radio :label="'0'">大华</el-radio>
                      <el-radio :label="'1'">旧设备</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="通信方式" prop="optModel">
                    <el-radio-group v-model="addForm.optModel">
                      <el-radio :label="'0'">UDP</el-radio>
                      <el-radio :label="'1'">串口</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="10" v-if="addForm.newFlag === 'Y'">
                <el-col :span="12">
                  <el-form-item label="继电器类型" prop="controlType">
                    <el-radio-group v-model="addForm.controlType" @change="handleControlTypeChange">
                      <el-radio :label="'0'">科星</el-radio>
                      <el-radio :label="'1'">泥人</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="addForm.controlType === '1'">
                  <el-form-item label="泥人IP" prop="controlIp">
                    <el-input v-model="addForm.controlIp"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="10" v-if="addForm.newFlag === 'Y'">
                <el-col :span="12">
                  <el-form-item label="上位机TOPIC" prop="upDeviceTopic">
                    <el-input v-model="addForm.upDeviceTopic"  style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="上位机TOPIC2" prop="upDeviceTopic2">
                    <el-input v-model="addForm.upDeviceTopic2"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-if="addForm.newFlag === 'Y'">
                <el-col :span="12">
                  <el-form-item label="淋浴时长" prop="lyTime">
                    <el-input v-model="addForm.lyTime">
                      <template slot="append">分钟</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="AB门类型" prop="doorType">
                    <el-radio-group v-model="addForm.doorType">
                      <el-radio :label="'0'">正常</el-radio>
                      <el-radio :label="'1'">单机器双门</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-if="addForm.newFlag === 'Y'">
                <el-col :span="12">
                  <el-form-item label="AB门IP" prop="doorIp">
                    <el-input v-model="addForm.doorIp"  style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="第二门IP" prop="doorIp2">
                    <el-input v-model="addForm.doorIp2"  style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" v-if="addForm.openStoreTime || addForm.closeStoreTime">
                <el-col :span="12">
                  <el-form-item label="闭店类型" prop="closeStatus">
                    <el-radio-group v-model="addForm.closeStatus" @change="handleCloseStatusChange">
                      <el-radio :label="item.val" v-for="(item, index) in closeTypes" :key="index">{{ item.text }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="addForm.closeStatus == '1'">
                  <el-form-item label="24小时门" prop="openDoor">
                    <el-radio-group v-model="addForm.openDoor">
                      <el-radio :label="item.val" v-for="(item, index) in doors" :key="index">{{ item.text }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="大厅继电器" v-if="addForm.newFlag === 'Y'">
                <el-button
                    type="primary"
                    plain
                    icon="el-icon-plus"
                    size="mini"
                    @click="handleAddRelay"
                >新增</el-button>
                <el-table :data="controls" height="250" border style="width: 100%">
                  <el-table-column type="index" label="序号" width="100" align="center"/>
                  <el-table-column prop="name" label="名称" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.name"  style="width:100%"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="relayNum" label="端口" align="center">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.relayNum" clearable placeholder="请选择">
                        <el-option
                            v-for="item in filterRelays(scope.row.relayNum)"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="autoFlag" label="自动运行" align="center">
                    <template slot-scope="scope">
                      <el-switch
                          onchange="handleAutoChange(scope.row)"
                          v-model="scope.row.autoFlag"
                          active-color="#13ce66"
                          inactive-color="#ff4949"
                          active-value="1"
                          inactive-value="0">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="autoFlag" label="自动类型" align="center">
                    <template slot-scope="scope">
                      <el-radio-group @change="handleAutoTypeChange(scope.row)" v-model="scope.row.autoType" v-if="scope.row.autoFlag === '1'">
                        <el-radio :label="'0'">定时</el-radio>
                        <el-radio :label="'1'">系统</el-radio>
                      </el-radio-group>
                    </template>
                  </el-table-column>
                  <el-table-column label="开始时间" align="center" width="300">
                    <template slot-scope="scope">
                      <el-time-picker
                          v-if="scope.row.autoType === '0'"
                          v-model="scope.row.startTime"
                          placeholder="开始时间">
                      </el-time-picker>
                    </template>
                  </el-table-column>
                  <el-table-column label="结束时间" align="center" width="300">
                    <template slot-scope="scope">
                      <el-time-picker
                          v-if="scope.row.autoType === '0'"
                          v-model="scope.row.endTime"
                          placeholder="结束时间">
                      </el-time-picker>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                      <el-button type="primary" @click="handleDeleteRelay(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item label="淋浴继电器" v-if="addForm.newFlag === 'Y'">
                <el-button
                    type="primary"
                    plain
                    icon="el-icon-plus"
                    size="mini"
                    @click="handleAddLy"
                >新增</el-button>
                <span style="color: red; font-size: 12px;margin-left: 10px">注：一个继电器最多绑定4个淋浴间</span>
                  <el-row :gutter="10" :key="i" style="margin-bottom: 15px" v-for="(ly, i) in lyRelays">
                    <el-col :span="18">
                      <el-input placeholder="请输入IP:PORT" v-model="ly.lyIp">
                        <template slot="prepend">UDP地址</template>
                      </el-input>
                    </el-col>
                    <el-col :span="6">
                      <el-button @click="handleDelLy(i)" type="danger" icon="el-icon-delete" circle></el-button>
                    </el-col>
                  </el-row>
              </el-form-item>
              <!-- 备注：非必填，管理员可见的内部说明（字段 store_info.remark） -->
              <el-form-item label="备注" prop="remark" class="remark-item">
                <el-input
                    v-model="addForm.remark"
                    type="textarea"
                    :rows="3"
                    maxlength="255"
                    show-word-limit
                    resize="none"
                    placeholder="请输入备注（选填，最多255字）"
                ></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button @click="handleCancel">取 消</el-button>
                  <el-button type="primary" @click="addStore" v-loading="btnLoading" v-permission="'btn:store:save'">确 定</el-button>
              </el-form-item>
          </el-form>

          <!-- 自定义标签管理弹窗：store-id 传 null → 不调接口，草稿只回传父组件，等保存门店时一起提交 -->
          <tag-manage-dialog
              :visible.sync="dialogVisible"
              :tag-type="dialogTagType"
              :store-id="null"
              :tags="dialogTagType === 1 ? serviceTags : facilityTags"
              :selected-uids="dialogTagType === 1 ? selectedServiceUids : selectedFacilityUids"
              :refreshing="refreshingTags"
              :highlight-names="dialogHighlightNames"
              @confirm="onTagConfirm"
          ></tag-manage-dialog>
        </el-card>

    </div>
</template>
<script>
import TxMap from "../../components/common/TXMap"
import {cities, fetchCities} from '@/assets/js/city.js'
import TagManageDialog from './TagManageDialog.vue'

export default {
    components: { TxMap, TagManageDialog },
    data(){
        return {
          btnLoading: false,
          // 自定义标签池（全量定义，每行带 uid）。勾选态单独放 data 顶层，不带进 addForm
          serviceTags: [],
          facilityTags: [],
          selectedServiceUids: [],
          selectedFacilityUids: [],
          // 给"进入页面"的标签发 tmp_x；只在发新号时递增
          tagSeed: 0,
          // 保存门店失败时后端回传的定位信息（data.tagErrors 原样存），提交前清空
          tagErrors: [],
          dialogVisible: false,
          dialogTagType: 1,
          refreshingTags: false,
          dialogHighlightNames: [],
          xyDates: [],
          // 级联选择器的选中状态（UI 状态），与提交字段 addForm.city 分离；
          // 绑 v-model 后清空才会真正生效，否则组件失焦会把缓存的选中值写回输入框
          citySelection: [],
          //添加表单数据
          addForm:{
            storename:'',
            city:'',
            address:'东营市广饶县',
            localtion:'',
            prov_name: "",
            city_name: "",
            district_name: "",
            latitude:'',
            longitude:'',
            storepic:'',
            roomnum:'',
            storearea:'',
            wechat:'',
            telephone:'',
            wifi:'',
            jianjie:'',
            isopen:1,
            sn:'',
            outsn:'',
            sn1:'',
            outsn1:'',
            camera1:'',
            camera2:'',
            camera3:'',
            camera4:'',
            fishsn:'',
            fishsn1:'',
            boxsn:'',
            wsdsn:'',
            dystoreid:'',
            gaodestoreid:'',
            newFlag: 'N',
            upDeviceTopic: '',
            upDeviceTopic2: '',
            lyTime: 20,
            xh: null,
            doorIp: null,
            doorIp2: null,
            controlType: '0',
            controlIp: null,
            faceLocal: 'N',
            isNewZhuapai: '0',
            doorType: '0',
            zhuapaiNum: null,
            lxjIp: null,
            openStoreTime: null,
            closeStoreTime: null,
            optModel: '0',
            faceDeviceType: '0',
            tyStartTime: null,
            tyStopTime: null,
            closeStatus: null,
            openDoor: null,
            musicTopic: null,
            dashboardTopic: null,
            stopCard: '0',
            clearNum: 3,
            settingNum: 3,
            associateNum: 3,
            ownerNum: 1,
            managerNum: 3,
            // 备注(store_info.remark):非必填,管理员可见的内部说明
            remark: ''
          },
          closeTypes: [
            {
              val: '0',
              text: '限制进入'
            }
          ],
          doors: [
            {
              val: '0',
              text: '第一门'
            },
            {
              val: '1',
              text: '第二门'
            }
          ],
          controls:[],
          lyRelays:[],
          //添加表单验证规则
          addFormRules:{
            xh:[
              { pattern: /^[1-9]\d{0,8}$/, message: '门店序号只能是数字必须以1-9开头', trigger: 'blur' }
            ],
            clearNum:[
              { pattern: /^[1-9]\d?$/, message: '保洁数量只能是整数', trigger: 'blur' }
            ],
            associateNum:[
              { pattern: /^[1-9]\d?$/, message: '店员数量只能是整数', trigger: 'blur' }
            ],
            ownerNum:[
              { pattern: /^[1-9]\d?$/, message: '店主数量只能是整数', trigger: 'blur' }
            ],
            managerNum:[
              { pattern: /^[1-9]\d?$/, message: '店长数量只能是整数', trigger: 'blur' }
            ],
            settingNum:[
              { pattern: /^[1-9]\d?$/, message: '保洁每月可改次数只能是整数', trigger: 'blur' }
            ],
              storename:[
                  { required: true, message: '请选输入门店名称', trigger: 'blur' }
              ],
              city:[
                  { required: true, message: '请选择所属城市', trigger: 'blur' }
              ],
              isopen:[
                  { required: true, message: '请选择店铺状态', trigger: 'blur' }
              ],
            longitude:[
                  { required: true, message: '请选择经纬度', trigger: 'blur' }
              ],
            upDeviceTopic:[],
            upDeviceTopic2:[
              { max: 50, message: '最大长度为50字符', trigger: 'change' }
            ],
            lyTime: [],
            doorIp: [
              { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
            ],
            doorIp2: [
              { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
            ],
            controlIp: [
              { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
            ],
            lxjIp: [
              { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/, message: 'IP格式XXX.XXX.XXX', trigger: 'blur' }
            ],
            zhuapaiNum: [
              { pattern: /^[1-9]\d{0,8}$/, message: '抓拍数量只能是数字必须以1-9开头', trigger: 'blur' }
            ]
          },
          cities:cities,
          citylist:[],
          statuslist:[],
          limitNum: 1,
          fileList:[],
          imgURL:this.GLOBAL.imgURL,
          uploadurl: this.GLOBAL.imgURL+'upload/',
          map: null,
          marker: null,
          relayNums: [
            {
              value: 0,
              label: '端口一'
            },
            {
              value: 1,
              label: '端口二'
            },
            {
              value: 2,
              label: '端口三'
            },
            {
              value: 3,
              label: '端口四'
            },
            {
              value: 4,
              label: '端口五'
            },
            {
              value: 5,
              label: '端口六'
            },
            {
              value: 6,
              label: '端口七'
            },
            {
              value: 7,
              label: '端口八'
            },
            {
              value: 8,
              label: '端口九'
            },
            {
              value: 9,
              label: '端口十'
            },
            {
              value: 10,
              label: '端口十一'
            },
            {
              value: 11,
              label: '端口十二'
            },
            {
              value: 12,
              label: '端口十三'
            },
            {
              value: 13,
              label: '端口十四'
            },
            {
              value: 14,
              label: '端口十五'
            },
            {
              value: 15,
              label: '端口十六'
            }
          ],
          nrRelayNums: [
            {
              value: 1,
              label: '端口一'
            },
            {
              value: 2,
              label: '端口二'
            },
            {
              value: 3,
              label: '端口三'
            },
            {
              value: 4,
              label: '端口四'
            },
            {
              value: 5,
              label: '端口五'
            },
            {
              value: 6,
              label: '端口六'
            },
            {
              value: 7,
              label: '端口七'
            },
            {
              value: 8,
              label: '端口八'
            }
          ]
        }
    },
    computed:{
      // 标签池按 10 个一组切行；空池必须返回 [[]] —— 否则「自定义标签管理」按钮没有挂载点
      serviceRows(){
        const rows = this.chunk(this.serviceTags, 10)
        return rows.length ? rows : [[]]
      },
      facilityRows(){
        const rows = this.chunk(this.facilityTags, 10)
        return rows.length ? rows : [[]]
      }
    },
    watch:{
      // 勾选数回到 6 以内时把「服务最多勾选」那条红字摘掉：后端只在保存时判一次，
      // 页面要能自己恢复（用户把第 7 个取消掉，红字不该一直挂着）
      selectedServiceUids(list){
        if (list.length > 6) return
        this.tagErrors = this.tagErrors.filter(e => e.code !== 'TOO_MANY_SELECTED')
      }
    },
    created () {
        this.getCityList()
        this.getStatusList()
        this.addressChange(15)
    },
    mounted(){
        this.addForm.admin_token = window.sessionStorage.getItem('admin_token')
    },
    methods:{
      // 门店服务最多勾 6 个：勾满后其余未勾选项置灰（已勾选的不禁，否则用户取消不掉）。
      // 6 与后端 StoreConstants.SERVICE_TAG_MAX_SELECTED 对应，改那边必须同步这里
      isServiceTagFull(item){
        return this.selectedServiceUids.length >= 6 && this.selectedServiceUids.indexOf(item.uid) < 0
      },
      // 标签进页面时补一次 uid：本页标签全是新建的（无 id），一律发 tmp_ 序号。
      // 不能每次打开弹窗重算 —— 那会让已勾选的 uid 全部悬空，页面上勾选凭空消失
      attachUid(list){
        return (list || []).map(t => ({
          ...t,
          uid: t.uid || (t.id != null ? 'id_' + t.id : 'tmp_' + (++this.tagSeed))
        }))
      },
      // 按 10 个一组切行：唯一硬要求是空数组返回 [[]]，否则管理按钮无处挂载
      chunk(list, size){
        const out = []
        for (let i = 0; i < (list || []).length; i += size) out.push(list.slice(i, i + size))
        return out
      },
      // 打开标签管理弹窗：先弹层、再补数据（本页没有 storeId，不请求接口，只用本地池）
      openTagDialog(tagType, highlightNames){
        this.dialogTagType = tagType
        this.dialogHighlightNames = highlightNames || []
        this.dialogVisible = true
        this.refreshingTags = false
      },
      // 整份替换页面池：uid 原样沿用，勾选态只剔除已删除的行。
      // 不读 newList.selected（旧值会抹掉本次未保存的勾选）
      applyTagList(tagType, newList){
        const key = tagType === 1 ? 'serviceTags' : 'facilityTags'
        const uids = tagType === 1 ? 'selectedServiceUids' : 'selectedFacilityUids'

        this[key] = this.attachUid(newList || [])
        const alive = new Set(this[key].map(t => t.uid))
        this[uids] = this[uids].filter(uid => alive.has(uid))
      },
      // 弹窗「确定」：不落库，草稿原样接过来（uid 已在弹窗内分配好），勾选数组不动 ——
      // 新建的标签默认未勾选，用户回页面自己勾
      onTagConfirm({ tagType, draft }){
        this.applyTagList(tagType, draft)
        this.recheckTagErrors(tagType)
      },
      // 池子换过之后重算：只在「仍然真的重名」时保留红字。
      // ⚠️ 不能只看"这个名字还在不在池里" —— 用户把 café 改成 咖啡后，
      //    cafe 还在池里但已经不重复了，按"还在"判会留下一条假红字
      recheckTagErrors(tagType){
        const names = (tagType === 1 ? this.serviceTags : this.facilityTags).map(t => this.normalizeName(t.name))
        const countOf = (n) => names.filter(x => x === n).length
        this.tagErrors = this.tagErrors.filter(e => {
          if (e.tagType !== tagType) return true            // 另一个池子的错误一律不动
          if (e.code === 'TOO_MANY_SELECTED') return true   // 与名字无关，交给勾选变化处理
          if (!e.name) return false                         // 空名行：池子改过就不再认定
          return countOf(this.normalizeName(e.name)) >= 2   // 只有在仍然重名时才留着
        })
      },
      // ---- 保存门店失败后的错误定位（后端 data.tagErrors） ----
      applyTagErrors(res){
        const errs = (res && res.data && res.data.tagErrors) || []
        this.tagErrors = errs
        return errs
      },
      // 后端把非标签类异常也拼了 "Add Failed: " 前缀，展示时去掉
      stripMsgPrefix(msg){
        return String(msg == null ? '' : msg).replace(/^Add Failed:\s*/, '')
      },
      // 表单很长，红字在下面看不见 → 定位到出问题的那一块
      scrollToTagBlock(tagType){
        const el = this.$refs['tagBlock' + tagType]
        const node = Array.isArray(el) ? el[0] : el
        if (node && node.scrollIntoView) node.scrollIntoView({ block: 'center', behavior: 'smooth' })
      },
      normalizeName(s){
        return String(s == null ? '' : s).trim().toLowerCase()
      },
      errorsOf(tagType){
        return (this.tagErrors || []).filter(e => e.tagType === tagType)
      },
      // 红框定位的主依据是 name 不是 index：重名一定有两条以上同名行，按 name 能一次全标红；
      // 按 index 只会亮一条，用户改完另一条还红着。index 只在 name 为空时兜底。
      isErrorTag(tagType, tag, flatIndex){
        const n = this.normalizeName(tag.name)
        return this.errorsOf(tagType).some(e => {
          if (e.name) return this.normalizeName(e.name) === n
          return e.index === flatIndex
        })
      },
      // 只有行级错误（重名/不合规）才给「去修改」；勾选超上限是在页面上点的，不需要进弹窗
      hasRowError(tagType){
        return this.errorsOf(tagType).some(e => e.code !== 'TOO_MANY_SELECTED')
      },
      errorText(tagType){
        const errs = this.errorsOf(tagType)
        if (!errs.length) return ''
        const dup = errs.filter(e => e.code === 'DUPLICATE_NAME').map(e => e.name)
        const bad = errs.filter(e => e.code === 'INVALID_NAME')
        const max = errs.find(e => e.code === 'TOO_MANY_SELECTED')
        const parts = []
        if (dup.length) parts.push('标签名重复：' + dup.join('、'))
        if (bad.length) parts.push('标签名不合规：' + bad.map(e => e.name || '（空）').join('、'))
        if (max) {
          // 用后端回报的 actual 而不是页面自己数的：页面可能已经改过勾选，
          // 文案要跟「被拒的那一次」对得上，否则用户看到 6 个却说超了 7 个
          parts.push((tagType === 1 ? '服务' : '设施') + '最多勾选 ' + max.limit + ' 个，当前 ' + max.actual + ' 个')
        }
        return parts.join('；')
      },
      // 把冲突名带进弹窗，进去就定位到那几行
      fixTags(tagType){
        const names = this.errorsOf(tagType).filter(e => e.name).map(e => e.name)
        this.openTagDialog(tagType, names)
      },
      // 手动触发单字段校验：用于 cascader 这类不自动派发 blur 校验事件的组件，
      // 以及经纬度这种一个 form-item 里放多个输入的复合字段，保证与普通输入框的失焦校验体验一致
      validateField(prop) {
        if (this.$refs.addFormRef) {
          this.$refs.addFormRef.validateField(prop, () => {})
        }
      },
      filterRelays(val){
        let arr = this.controls.map(item=> item.relayNum)
        if (this.addForm.controlType == '0') {
          return this.relayNums.filter(relay => arr.indexOf(relay.value) === -1 || relay.value === val)
        } else {
          return this.nrRelayNums.filter(relay => arr.indexOf(relay.value) === -1 || relay.value === val)
        }
      },
        setAddress(newAddress) {
            this.addForm.address =  newAddress.formatted_addresses.recommend; //地址
            this.addForm.latitude = newAddress.location.lat; //纬度
            this.addForm.longitude = newAddress.location.lng; //经度
            this.addForm.prov_name = newAddress.address_component.province; //省
            this.addForm.city_name = newAddress.address_component.city; //市
            this.addForm.district_name = newAddress.address_component.district; //区
          console.log(this.addForm)
            this.addForm = Object.assign({}, this.addForm, {
            address: newAddress.formatted_addresses.recommend,
            });
            // 地图选点回填经纬度后立即重校验，清除之前空值时留下的"必填"红框
            this.validateField('longitude');
            // console.log("this.form.store_address", this.form.store_address);
        },
        // 地址搜索事件
      addressChange(zoom = 15) {
        let map_key = "GX3BZ-2XRK4-JIOUX-XP53Z-P2AV3-VIBZU"; //腾讯地图key
        //省市区
        let prov_name = this.addForm.prov_name || "",
          city_name = this.addForm.city_name || "",
          district_name = this.addForm.district_name || "";
        //如果有省市区的选择，地图搜索就要把省市区组装起来，传入到address参数里
        let store_city = prov_name + city_name + district_name;

        // 地址转坐标
        this.$jsonp(
          `https://apis.map.qq.com/ws/geocoder/v1/?output=jsonp&key=${map_key}&address=${store_city}${this.addForm.address}`
        ).then((res) => {
          // 根据点击地点获取经纬度
          let lat = res.result.location.lat; //纬度
          let lng = res.result.location.lng; //经度
          //在地图上定位地点
          this.$refs["map"].init(
            zoom,
            lat,
            lng,
            this.addForm.address
          );
        });
      },
        async getCityList(){
            await fetchCities();
            const transformedData = this.cities.map(city => {
                const cityObject = {
                    value: city.name,
                    label: city.name,
                    children: city.districts ? city.districts.map(district => ({
                        value: district,
                        label: district
                    })) : []
                };
                return cityObject;

            });
            this.citylist = transformedData
        },
        async getStatusList(){
            const { data: res } = await this.$http.get('status/')
            this.statuslist = res.data
        },

        addPic(file, fileList){
            this.addForm.storepic = file.picname
        },
        // 上传前校验：仅允许 jpg/png，且不超过 2M（返回 false 时 el-upload 会终止上传）
        beforePicUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJpgOrPng) {
                this.$message.error('只能上传 JPG/PNG 格式的图片!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isJpgOrPng && isLt2M;
        },
       handleChange(value) {
        if (!value || value.length === 0) {
          // 用户通过清空按钮/清空输入框清除了城市：只清提交字段并重校验，不动地址
          this.addForm.city = '';
          this.validateField('city');
          return;
        }
        console.log(value);
        this.addForm.city = value.join(', ')
        this.addForm.address = value[0]+value[1]
        this.addressChange(15)
        // 选择城市后立即重校验，清除之前空值时留下的"必填"红框
        this.validateField('city')
      },
      // 级联输入框的原生输入事件（只来自真实键入）：记录用户是否把内容清空了
      onCityNativeInput(e) {
        this._cityTextEmpty = !(e && e.target && e.target.value && e.target.value.trim());
      },
      // 级联失焦：若用户清空了内容，真正清掉选中值，避免组件把缓存的选中项回填到输入框
      onCityBlur(e) {
        const text = e && e.target && e.target.value != null ? e.target.value.trim() : '';
        if (!text || this._cityTextEmpty) {
          // 程序置空不会触发 cascader 的 change（仅用户操作才发），所以这里自己完成清理
          this.citySelection = [];
          this.addForm.city = '';
          this.validateField('city');
          this._cityTextEmpty = false;
          return;
        }
        this.validateField('city');
      },
      changePic(file, fileList){
        console.log(this.fileList);
      },
      async addStore(){
          this.$refs.addFormRef.validate( async valid=>{
          if (!valid) return

            let controls = []
            let lyControls = []
            if (this.addForm.newFlag === "Y") {
              let ipValid = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/

              let sign = 0
              if (this.controls.length === 0 && this.addForm.isopen == '1') {
                this.$message.error('新设备不可以不添加大厅继电器！');
                return
              }
              this.controls.forEach((control, index) => {
                let obj = {...control}
                if (!control.name) {
                  obj.name = '继电器' + (index + 1)
                }
                if (control.relayNum == null) {
                  sign = 1
                }
                if (control.autoType === '0') {
                  if (!control.startTime) {
                    sign = 2
                  } else {
                    obj.startTime = control.startTime.getTime()
                  }
                  if (!control.endTime) {
                    sign = 6
                  } else {
                    obj.endTime = control.endTime.getTime()
                  }
                }
                controls.push(obj)
              })
              if (sign === 2) {
                this.$message.error('大厅继电器定时开启不可以不设置开启时间！');
                return
              } else if (sign === 6) {
                this.$message.error('大厅继电器定时开启不可以不设置关闭时间！');
                return
              } else if (sign === 1) {
                this.$message.error('大厅继电器不可以不设置端口！');
                return
              }
              this.addForm.controls = controls
              if (this.lyRelays.length === 0 && this.addForm.isopen == '1') {
                this.$message.error('新设备不可以不添加淋浴继电器！');
                return
              }
              this.lyRelays.forEach((control) => {
                if (!control.lyIp) {
                  sign = 3
                } else if (!ipValid.test(control.lyIp)) {
                  sign = 4
                }
                lyControls.push(control)
              })

              if (sign === 3) {
                this.$message.error('淋浴继电器必须设置IP地址！');
                return
              }else if (sign === 4) {
                this.$message.error('淋浴继电器IP地址格式不对，格式IP:PORT！');
                return
              }
              this.addForm.lyControls = lyControls
            }

            let obj = {...this.addForm}
            if (obj.openStoreTime) {
              obj.openStoreTime = obj.openStoreTime.getTime()
            }
            if (obj.closeStoreTime) {
              obj.closeStoreTime = obj.closeStoreTime.getTime()
            }
            if (this.xyDates && this.xyDates.length > 0) {
              obj.tyStartTime = this.xyDates[0].getTime()
              obj.tyStopTime = this.xyDates[1].getTime()
            }
            // 自定义标签：整份池子提交（name + selected + sort），后端建店时一起落库。
            // store_info.services / facilities 两列已作废，不再提交
            obj.serviceTagList = this.serviceTags.map((t, i) => ({
              name: String(t.name || '').trim(),
              selected: this.selectedServiceUids.indexOf(t.uid) >= 0 ? 1 : 0,
              sort: (i + 1) * 10
            }))
            obj.facilityTagList = this.facilityTags.map((t, i) => ({
              name: String(t.name || '').trim(),
              selected: this.selectedFacilityUids.indexOf(t.uid) >= 0 ? 1 : 0,
              sort: (i + 1) * 10
            }))

            if (!obj.managerNum) {
              obj.managerNum = null
            }
            if (!obj.ownerNum) {
              obj.ownerNum = null
            }
            if (!obj.associateNum) {
              obj.associateNum = null
            }
            if (!obj.clearNum) {
              obj.clearNum = null
            }
            if (!obj.settingNum) {
              obj.settingNum = null
            }

            // 发请求前清空上一轮的定位信息，避免上次的红字误导这一次
            this.tagErrors = []

            this.btnLoading = true
            const { data:res } = await this.$http.post('storeadd/',obj)
            this.btnLoading = false
            if(res.status===0)
            {
                this.$message.success('添加门店成功！')
                // 使用完全刷新的方式返回门店列表，确保组件完全卸载并重新加载
                window.location.href = '#/stores'
            } else {
              const errs = this.applyTagErrors(res)
              this.$message.error(this.stripMsgPrefix(res.message) || '添加门店失败')
              // 有定位信息时把视口滚到出问题的那一块，否则表单很长、用户找不到红字在哪
              if (errs.length) this.$nextTick(() => this.scrollToTagBlock(errs[0].tagType))
            }
          })
       },
      handleFlagChange() {
        this.addForm.controlType = '0'
        this.addForm.upDeviceTopic = null
        this.addForm.upDeviceTopic2 = null
        this.addForm.lyTime = null
        this.controls = []
        this.lyRelays = []
        this.addFormRules.upDeviceTopic = []
        this.addFormRules.lyTime = []
        // this.addFormRules.doorIp = [
        //   { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
        // ]
        if (this.addForm.isopen == '1' && this.addForm.newFlag === 'Y') {
          this.addFormRules.upDeviceTopic = [
            { required: true, message: '请输入上位机TOPIC', trigger: 'change' },
            { max: 50, message: '最大长度为50字符', trigger: 'change' }
          ]
          this.addFormRules.lyTime = [
            { required: true, message: '请输入淋浴时长', trigger: 'change' },
            { pattern: /^[1-9]|([1,2]\d)|30$/, message: '淋浴时长最小1最大30', trigger: 'blur' }
          ]
          // this.addFormRules.doorIp = [
          //   { required: true, message: '请输入AB门ip', trigger: 'change' },
          //   { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
          // ]
        }
      },
      handleControlTypeChange() {
        this.addForm.controlIp = null
        this.addFormRules.controlIp = [
          { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
        ]
        if (this.addForm.controlType == '1') {
          this.addFormRules.controlIp = [
            { required: true, message: '请输入泥人IP', trigger: 'change' },
            { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
          ]
        }
      },
      handleCancel() {
        // 使用完全刷新的方式导航到添加门店页面
        window.location.href = '#/stores'
      },
      handleDeleteRelay(index) {
          this.controls.splice(index, 1)
      },
      handleAddRelay(){
        if (this.addForm.controlType == '1') {
          if (this.controls.length < 8) {
            this.controls.push({
              relayNum: null,
              name: null,
              autoFlag: '1',
              autoType: '1',
              dsTimeArr: null
            })
          } else {
            this.$message.error('最多只能增加8个继电器端口哦');
          }
        } else {
          if (this.controls.length < 16) {
            this.controls.push({
              relayNum: null,
              name: null,
              autoFlag: '1',
              autoType: '1',
              dsTimeArr: null
            })
          } else {
            this.$message.error('最多只能增加16个继电器端口哦');
          }
        }
      },
      handleAutoChange(row){
          if (row.autoFlag === '0') {
            row.autoType = null
          } else {
            row.autoType = '1'
          }
        row.dsTimeArr = null
      },
      handleAutoTypeChange(row){
          if (row.autoType === '1') {
            row.startTime = null
            row.endTime = null
          }
      },
      handleAddLy() {
        this.lyRelays.push({
          lyIp: "127.0.0.1:520" + this.lyRelays.length,
          lyKey: this.generateUUID()
        })
      },
      handleDelLy(i) {
        this.lyRelays.splice(i, 1)
      },
      generateUUID() {
        let timestamp = new Date().getTime();
        return 'xxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = (timestamp + Math.random() * 16) % 16 | 0;
          timestamp = Math.floor(timestamp / 16);
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
      },
      handleZhapaiChange(val) {
        this.addFormRules.lxjIp = [
          { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/, message: 'IP格式XXX.XXX.XXX', trigger: 'blur' }
        ]
        this.addFormRules.zhuapaiNum = [
          { pattern: /^[1-9]\d{0,8}$/, message: '抓拍数量只能是数字必须以1-9开头', trigger: 'blur' }
        ]
        this.addForm.lxjIp = null
        this.addForm.zhuapaiNum = null
        this.addForm.camera1 = null
        this.addForm.camera2 = null
        this.addForm.camera3 = null
        this.addForm.camera4 = null
        if (val === '1') {
          this.addFormRules.lxjIp = [
            { required: true, message: '请选输入录像机IP', trigger: 'blur' },
            { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/, message: 'IP格式XXX.XXX.XXX', trigger: 'blur' }
          ]
          this.addFormRules.zhuapaiNum = [
            { required: true, message: '请选输入抓拍数量', trigger: 'blur' },
            { pattern: /^[1-9]\d{0,8}$/, message: '抓拍数量只能是数字必须以1-9开头', trigger: 'blur' }
          ]
        }
      },
      handleOpenStoreTime() {
        if (!this.addForm.closeStoreTime && !this.addForm.openStoreTime) {
          this.addForm.closeStatus = null
          this.addForm.openDoor = null
        } else {
          if (!this.addForm.closeStatus) {
            this.addForm.closeStatus = '0'
            this.addForm.openDoor = null
          }
        }
      },
      handleTwoDoorChange(val) {
        if (this.addForm.sn1 || this.addForm.outsn1) {
          this.closeTypes = [
            {
              val: '0',
              text: '限制进入'
            },
            {
              val: '1',
              text: '限制进出'
            }
          ]
        } else {
          this.closeTypes = [
            {
              val: '0',
              text: '限制进入'
            }
          ]

          if (this.addForm.closeStoreTime || this.addForm.openStoreTime) {
            this.addForm.closeStatus = '0'
            this.addForm.openDoor = null
          }
        }
      },
      handleCloseStatusChange() {
        this.addForm.openDoor = null
      }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;

    }
    .el-breadcrumb{
        width: 100%;
    }
    #map {
        width: 100%;
        height: 500px;
    }

    /* 备注文本域：标签与多行输入框精确垂直居中，去掉悬空感 */
    .remark-item {
        display: flex;
        align-items: center;
    }
    .remark-item ::v-deep .el-form-item__label {
        float: none;
        line-height: normal;
        padding-bottom: 0;
    }
    .remark-item ::v-deep .el-form-item__content {
        flex: 1;
        margin-left: 0 !important;
    }
    .remark-item ::v-deep .el-textarea__inner {
        resize: none;
        line-height: 1.6;
    }
    .remark-item ::v-deep .el-input__count {
        background: transparent;
        color: #c0c4cc;
        line-height: 20px;
        bottom: 4px;
        right: 10px;
    }

    /* 表单工整度：仅作用于本表单（style 无 scoped，避免污染全局） */
    .store-form .el-checkbox {
        margin-right: 14px;
    }
    .store-form .el-checkbox:last-child {
        margin-right: 0;
    }
    .store-form .el-radio {
        margin-right: 16px;
    }
    .store-form .el-form-item__content {
        /* 纯文本字段（如门店名称）与 32px 输入框基线对齐 */
        line-height: 32px;
    }

    /* 自定义标签：10 个一组切行，组内放不下继续换行 */
    .store-form .tag-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
    /* Element 给 .el-checkbox-group 设了 font-size:0 吃掉行内空白，这里的 font-size 不能省 —— 省了「暂未提供」直接消失 */
    .store-form .tag-empty {
        font-size: 12px;
        color: #999;
        margin-right: 12px;
    }
    .store-form .tag-manage-btn {
        padding: 0;
        font-size: 14px;
    }
    /* 冲突标签在页面上直接标红，用户不用打开弹窗也知道是哪两条。
       class 落在 el-checkbox 根节点 label.el-checkbox 上，但 __label / __inner 是子组件内部节点、
       不带本组件的 data-v 属性，scoped 下必须用 ::v-deep 才能穿透（与 .remark-item 那几处同一写法） */
    .store-form .tag-group .tag-dup ::v-deep .el-checkbox__label {
        color: #F56C6C;
    }
    .store-form .tag-group .tag-dup ::v-deep .el-checkbox__inner {
        border-color: #F56C6C;
    }
    /* 错误条：一行放不下自动换行，不撑破 form-item */
    .store-form .tag-error {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 4px;
        font-size: 12px;
        line-height: 20px;
        color: #F56C6C;
    }
    .store-form .tag-error i {
        margin-right: 4px;
        font-size: 13px;
    }
    .store-form .tag-error .tag-error-fix {
        padding: 0;
        margin-left: 8px;
        font-size: 12px;
        color: #F56C6C;
    }

</style>
